import React from "react";
import "swiper/css";
// import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link, useNavigate } from "react-router-dom";
import { MdArrowOutward } from "react-icons/md";
import styles from "./card.module.css";

const ScreenCard = () => {
  const myData = [
    {
      title: "Enover",
      subtitle:
        "With Enover’s EHP technology, you can reduce the cost a lot while providing the highest energy efficiency!",
      description:
        "EHP, is the world’s fastest, most cost-effective, simplest, cheapest, three-phase single heat transfer technology that can operate in various geometric shapes without the need for secondary processing.",
      imageUrl: "images/icon/logo_1.png",
      btn: "Read More",
    },
    {
      title: "Finsertech",
      subtitle:
        "With Finsertech technology, we are ready to extract Natural resources from nature Like gold ore",
      description:
        "EHP, is the world’s fastest, most cost-effective, simplest, cheapest, three-phase single heat transfer technology that can operate in various geometric shapes without the need for secondary processing.",
      imageUrl: "images/icon/logo_2.png",
      btn: "Read More",
    },
    {
      title: "20solarenergy",
      subtitle: "Everyday Essentials to Luxury Indulgence",
      description:
        "EHP, is the world’s fastest, most cost-effective, simplest, cheapest, three-phase single heat transfer technology that can operate in various geometric shapes without the need for secondary processing.",
      imageUrl: "images/icon/logo_3.png",
      btn: "Read More",
    },
    {
      title: "H Nordiac",
      subtitle:
        "With H Nordiac Axis Wind Turbine is a groundbreaking solution for modern, Eco conscious shipping.",
      description:
        "EHP, is the world’s fastest, most cost-effective, simplest, cheapest, three-phase single heat transfer technology that can operate in various geometric shapes without the need for secondary processing.",
      imageUrl: "images/icon/logo_4.png",
      btn: "Read More",
    },
    {
      title: "The Green Life Industries",
      subtitle:
        "The Green Life Industries with innovative projectsto craft and distribute organic raw materials",
      description:
        "The Nuclear Grade Micro Grind Machine (MGM) - used in conjunction with the SSP to provide the rapid and low-cost production of Graphene for Electric Vehicle (EV) Battery manufacturing at 10% of the Weight or 10X the Power Capacity, and 30% the cost of standard Lithium EV Batteries.",
      imageUrl: "images/icon/logo_5.png",
      btn: "Read More",
    },
  ];

  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/product`);
  };

  return (
    <Swiper
      slidesPerView={3}
      spaceBetween={30}
      // modules={[Autoplay]}
      // autoplay={{
      //   delay: 2000,
      //   disableOnInteraction: false,
      // }}
      className={`${styles.mySwiper} mb-4`}
      breakpoints={{
        320: { slidesPerView: 1, spaceBetween: 10 },
        768: { slidesPerView: 3, spaceBetween: 20 },
        1024: { slidesPerView: 3, spaceBetween: 30 },
      }}
    >
      {myData.map(({ title, subtitle, description, imageUrl, btn }, index) => (
        <SwiperSlide key={index}>
          <div
            className={styles.card}
            onClick={handleClick}
            role="button"
            aria-label={`View details for ${title}`}
          >
            <div className={styles.left}>
              <div className={styles.header}>
                <img src={imageUrl} alt={`${title} logo`} />
                <h1 className={styles.title}>{title}</h1>
              </div>
              <h2 className={styles.subtitle}>{subtitle}</h2>
              <p className={styles.description}>{description}</p>
              <Link to="#">
                {btn} <MdArrowOutward className={styles.icon} />
              </Link>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ScreenCard;
